import { type QueryHookOptions, useQuery } from "@apollo/client";
import { UsersListQuery } from "../graphql/queries";
import type { UsersListQueryType } from "@/types/graphql/partner.generated";

export const useUsersQuery = (
  options?: QueryHookOptions<UsersListQueryType>
) => {
  return useQuery<UsersListQueryType>(UsersListQuery, options);
};
